export const API_BASE_URL = "https://api.akacademy.net";